import $ from 'jquery';

import { FireHelpers } from '@base';

// hide all svg elements from screen readers
$('svg').attr('aria-hidden', 'true');
